module.exports = __webpack_public_path__ + "static/img/19_pro.2707b6b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/19_pro.jpg
// module id = b3+U
// module chunks = 0